(function () {
  'use strict';

  var selector = '[data-navega-home-hero]';

  function matchesOrFind(root, query) {
    var items = [];
    if (root && root.nodeType === 1 && root.matches(query)) items.push(root);
    if (root && root.querySelectorAll) {
      root.querySelectorAll(query).forEach(function (item) { items.push(item); });
    }
    return items;
  }

  function showSlide(hero, index) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-navega-home-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-navega-home-dot]'));
    if (!slides.length) return;
    var next = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === next;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    hero.dataset.navegaHomeIndex = String(next);
  }

  function initHero(hero) {
    if (hero.dataset.navegaHomeReady === 'true') return;
    var slides = hero.querySelectorAll('[data-navega-home-slide]');
    if (!slides.length) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var intervalId = null;
    var interval = Math.max(Number(hero.dataset.interval || 6), 3) * 1000;
    var autoplay = hero.dataset.autoplay === 'true' && slides.length > 1;

    function currentIndex() {
      return Number(hero.dataset.navegaHomeIndex || 0);
    }

    function stopAutoplay() {
      if (intervalId) window.clearInterval(intervalId);
      intervalId = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      intervalId = window.setInterval(function () { showSlide(hero, currentIndex() + 1); }, interval);
    }

    var previous = hero.querySelector('[data-navega-home-previous]');
    var next = hero.querySelector('[data-navega-home-next]');
    if (previous) previous.addEventListener('click', function () {
      showSlide(hero, currentIndex() - 1);
      startAutoplay();
    }, { signal: signal });
    if (next) next.addEventListener('click', function () {
      showSlide(hero, currentIndex() + 1);
      startAutoplay();
    }, { signal: signal });

    hero.querySelectorAll('[data-navega-home-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(hero, Number(dot.dataset.slideIndex || 0));
        startAutoplay();
      }, { signal: signal });
    });

    hero.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showSlide(hero, currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
      startAutoplay();
    }, { signal: signal });

    hero.addEventListener('mouseenter', stopAutoplay, { signal: signal });
    hero.addEventListener('mouseleave', startAutoplay, { signal: signal });
    hero.addEventListener('focusin', stopAutoplay, { signal: signal });
    hero.addEventListener('focusout', startAutoplay, { signal: signal });

    hero.navegaHomeTeardown = function () {
      stopAutoplay();
      controller.abort();
      delete hero.navegaHomeTeardown;
      delete hero.dataset.navegaHomeReady;
    };
    hero.dataset.navegaHomeReady = 'true';
    showSlide(hero, currentIndex());
    startAutoplay();
  }

  function init(root) {
    matchesOrFind(root || document, selector).forEach(initHero);
  }

  function teardown(root) {
    matchesOrFind(root || document, selector).forEach(function (hero) {
      if (hero.navegaHomeTeardown) hero.navegaHomeTeardown();
    });
  }

  function ready() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { teardown(event.target); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target.closest('[data-navega-home-slide]');
    var hero = event.target.closest(selector);
    if (!block || !hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-navega-home-slide]'));
    showSlide(hero, slides.indexOf(block));
  });

  window.NavegaHome = { init: init, teardown: teardown };
}());
